import "./RoofingScaffolding.module.css";
import Header from "@/reusable_sections/Header";
import Partnership from "./sections/Partnership";
import Contractors from "./sections/Contractors";
import Quote from "./sections/Quote";
import Footer from "@/reusable_sections/Footer";
export default function RoofingScaffoldingPage() {
  return <div>
      <Header />
      <Partnership />
      <Contractors />
      <Quote />
      <Footer />
    </div>;
}